import * as Yup from "yup";

export const schemaNewPassword = Yup.object().shape({
  password: Yup.string().min(6).required("Password is a required field"),
  newPassword: Yup.string()
    .min(6)
    .required("Confirm password is a required field"),
});
